import { absoluteImageUrl } from '../utils/environment'
import { GiftCard } from '../../types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fromStrapiGiftCard = (strapiData: any): GiftCard => {
    const { attributes } = strapiData
    const { giftCard, title } = attributes

    return {
        title,
        giftCard: absoluteImageUrl(giftCard.data.attributes.url),
    }
}

export { fromStrapiGiftCard }